module.exports = __webpack_public_path__ + "img/haunted-wine-bottle.c8b2d4eb.png";